/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S5_Li1Inputs */

const tr_mesafeli_s5_li1 = /** @type {(inputs: Mesafeli_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faturalandırma aylık veya yıllık olarak gerçekleşir; yıllık ödemede Platform üzerinde ilan edilen oranda indirim uygulanır.`)
};

const en_mesafeli_s5_li1 = /** @type {(inputs: Mesafeli_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing takes place monthly or annually; for annual payment the discount announced on the Platform is applied.`)
};

const de_mesafeli_s5_li1 = /** @type {(inputs: Mesafeli_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Abrechnung erfolgt monatlich oder jährlich; bei jährlicher Zahlung wird der auf der Plattform veröffentlichte Rabatt gewährt.`)
};

const ru_mesafeli_s5_li1 = /** @type {(inputs: Mesafeli_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выставление счетов производится ежемесячно или ежегодно; при годовой оплате применяется скидка, объявленная на Платформе.`)
};

/**
* | output |
* | --- |
* | "Billing takes place monthly or annually; for annual payment the discount announced on the Platform is applied." |
*
* @param {Mesafeli_S5_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s5_li1 = /** @type {((inputs?: Mesafeli_S5_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S5_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s5_li1(inputs)
	if (locale === "de") return de_mesafeli_s5_li1(inputs)
	if (locale === "ru") return ru_mesafeli_s5_li1(inputs)
	return tr_mesafeli_s5_li1(inputs)
});